import { setStylesOnElement } from "../util/Misc";
import Message from "../model/Message";
import BubbleType from "../model/BubbleType";
import { FOCUS_SETTINGS } from "../model/Constants";

/**
 * logging disclaimer to historic transcript for reporting
 * @param {CIApp} CIApp instance
 */
export function sendDisclaimerAsDataPass(appInstance) {
    const stringProps = appInstance.getUIConfig().appStringProps;

    if (appInstance.getUIConfig().appConfigProps.logDisclaimer && !appInstance.getRestoring()) {
        if (stringProps.disclaimerHeaderText) {
            appInstance.getSDKInstance().sendDataPass({ disclaimer: stringProps.disclaimerHeaderText });
        }

        if (stringProps.disclaimerFooterText) {
            appInstance.getSDKInstance().sendDataPass({ disclaimer: stringProps.disclaimerFooterText });
        }
    }
}

/**
 * creates and returns a button element
 * @param {string} className
 * @param {string} text
 * @param {Object} styleObj
 * @param {function} handler
 * @return {Button}
 */
export function createButton(className, text, styleObj, handler) {
    const newMsgBtn = document.createElement("button");
    newMsgBtn.classList.add(className);
    newMsgBtn.innerText = text;

    if (styleObj) {
        setStylesOnElement(styleObj, newMsgBtn);
    }

    newMsgBtn.onclick = handler;
    return newMsgBtn;
}

export function addMessageBubbleToTranscriptInChatWindow($app, text, state, persist?) {
    // Do not add message Bubble if text is empty undefined or null
    if (text) {
        /** @type {Message} constructing System Message Bubble */
        const msg = new Message({
            bubbleType: BubbleType.SYSTEM_MESSAGE,
            messageText: text,
        });
        msg.setInternalState(state);
        msg.persistInTranscript(!!persist);
        $app.addToUI(msg);
    }
}

/**
 *
 * @param {Boolean} deleteBlocking - delete immediately if true
 * @param {HTMLElement} element
 */
export function deleteElement(deleteBlocking, element) {
    if (deleteBlocking) {
        element.parentElement.removeChild(element);
    } else {
        window.raf(() => {
            element.parentElement.removeChild(element);
        });
    }
}

/**
 * @param {BubbleType} type - bubble type to check
 * @return {boolean} - true/false
 */
export function isBubbleTypeRichMediaWidget(type) {
    if (type === BubbleType.RICH_MESSAGE_RECEIPT
        || type === BubbleType.RICH_MESSAGE_FORM
        || type === BubbleType.RICH_MESSAGE_QR
        || type === BubbleType.RICH_MESSAGE_CARD
        || type === BubbleType.RICH_MESSAGE_OTHER
    ) {
        return true;
    }
    return false;
}


export function handleCommandEvent(eventData, sdkInstance) {
    if(Array.isArray(eventData)) {
        eventData.forEach((event) => {
            fireCustomEvent(event, sdkInstance);  
        })            
    } else {
        fireCustomEvent(eventData, sdkInstance);  
    }
}

function fireCustomEvent(eventObj, sdkInstance) {
    try {
        for (const [key, value] of Object.entries(eventObj)) {
            sdkInstance.fireCustomEvent(key, value);
        }
    } catch(e) { 
        sdkInstance.logError(e)
    }
}

/**
 * when uiconfig property focusOnAgentMessage is set to onNewAgentMessage then aria reader should skip reading the bubble text
 * and thats why we need to add negative tabindex so that keybaord navigation will skip text
 * @param {element} HTML element
 * @param {appInstance} CIApp instance
 */
export function customOutOfFocus(element: HTMLElement, appInstance) {
    if (appInstance.focusOnAgentMessage === FOCUS_SETTINGS.ON_NEW_AGENT_MESSAGE) {
        element.setAttribute("tabindex", "-1");
    }
}